import SwivuSettingsTagValueTabBase from "./SwivuSettingsTagValueTabBase.jsx";
import { TAGS_KEYS } from "../../../other/constants/TagsKeys.jsx";
import { STORE_KEYS } from "../../../other/constants/StoreKeys.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";
import {SETTING_TAB_WIDGET_KEYS} from "../../../other/constants/OtherKeys.jsx";

const GRID_KEYS = {
  taskPhaseGrid: "taskPhaseGrid"
};

export default class SwivuSettingsTaskPhaseTab extends SwivuSettingsTagValueTabBase {
  static get $name() {
    return "SwivuSettingsTaskPhaseTab";
  }

  static get type() {
    return "swivusettingstaskphasetab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.taskPhaseTab;
  }

  getStoreName() {
    return STORE_KEYS.taskTagValuesStore;
  }

  getTagKeysWithWidgetRef() {
    return {
      [TAGS_KEYS.phase]: GRID_KEYS.taskPhaseGrid
    };
  }

  swivuCheckGrants(user) {
    if (!user.can(GRANTS.grant_one)) {
      const grid = this.widgetMap[GRID_KEYS.taskPhaseGrid];
      grid.disabled = true;
      grid.readOnly = true; // readonly will prevent row reorder
      grid.bbar.items.forEach(
        (item) => (item.disabled = true)
      );
    }
  }

  static get configurable() {
    return {
      title: "Phase",
      ...SwivuSettingsTagValueTabBase.getDefaultLayoutSettings(),
      items: {
        [GRID_KEYS.taskPhaseGrid]: SwivuSettingsTagValueTabBase.getGridWidget({
          headerText: "Phase",
          defaultValue: "Enter Phase",
        })
      }
    };
  }
}

SwivuSettingsTaskPhaseTab.initClass();
